export const faveActionTypes = {
    ADD_TO_FAVE: 'ADD_TO_FAVE',
    REMOVE_FROM_FAVE: 'REMOVE_FROM_FAVE'
}